import React from "react";
import { Link } from "react-router-dom";

export function KpiCard({ label, value, sub, hint, accent = "primary", icon, testid, to }) {
  const accents = {
    primary: "text-emerald-900",
    amber: "text-amber-700",
    blue: "text-blue-800",
    red: "text-red-700",
    purple: "text-violet-700",
  };
  const inner = (
    <>
      <div className="flex items-start justify-between">
        <div className="data-label">{label}</div>
        {icon && <div className="text-stone-400">{icon}</div>}
      </div>
      <div className={`mt-2 font-mono text-2xl font-semibold tracking-tight ${accents[accent]}`}>
        {value}
      </div>
      {sub && <div className="mt-1 font-mono text-xs text-stone-500">{sub}</div>}
      {hint && <div className="mt-2 text-[11px] text-stone-400">{hint}</div>}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="panel p-4 block hover:shadow-md hover:border-emerald-300 hover:-translate-y-0.5 transition-all duration-150 cursor-pointer"
        data-testid={testid}
      >
        {inner}
      </Link>
    );
  }

  return (
    <div className="panel p-4 hover:shadow-sm transition-shadow" data-testid={testid}>
      {inner}
    </div>
  );
}
